import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../services/analytics";
import { getRouteProperties } from "../services/analyticsEvents";

const AnalyticsRouteTracker = () => {
	const location = useLocation();

	useEffect(() => {
		trackPageView(getRouteProperties(location));
	}, [location.pathname, location.search]); // eslint-disable-line react-hooks/exhaustive-deps

	return null;
};

export default AnalyticsRouteTracker;
